export const VoucherOrderStatus={
    Pending:0,
    Canceled:1,
    Active:2,
    Inactive:3
}
